const GOOGLE_SHEET_APIKEY = 'AIzaSyDTwzwe3imVwr-bakncGImvb2MRHcuI0tc';
const GOOGLE_SHEET_ID = '1FvOlICuSWm22wUh3cEhHrLTa36z33-H3cH-pFvWHEM0'; // production master spreadsheet
const SPREAD_SHEET_API_ROOT = `https://sheets.googleapis.com/v4/spreadsheets/${GOOGLE_SHEET_ID}`;

export async function fetchSpreadsheetData() {
  try {
    const sheetRes = await fetch(
      `${SPREAD_SHEET_API_ROOT}?key=${GOOGLE_SHEET_APIKEY}`
    ).then((sheetRes) => sheetRes.json());
    if (sheetRes.error)
      throw new Error(`Get sheetData error! ${sheetRes.error.message}`);
    const batchGetQuery =
      sheetRes.sheets
        .map((sheet) => `ranges=${sheet.properties.title}`)
        .join('&') + `&key=${GOOGLE_SHEET_APIKEY}`;
    const tableRes = await fetch(
      `${SPREAD_SHEET_API_ROOT}/values:batchGet?${batchGetQuery}`
    ).then((valueRes) => valueRes.json());
    if (tableRes.error)
      throw new Error(`Get tableData error!${tableRes.error.message}`);
    const parsedData = parseSheets(tableRes.valueRanges);
    validation(parsedData);
    return parsedData;
  } catch (e) {
    console.error(`Spreadsheet parse error! ${e}`);
  }
}

function parseSheets(sheetValues) {
  return sheetValues.reduce((data, { range, values }) => {
    const tableName = range.substr(0, range.indexOf('!'));
    if (data[tableName]) throw new Error(`Duplicate table ${tableName}.`);
    data[tableName] = {};
    const trimmedTitle = values[0].map((value) => value.trim());
    for (let rowIdx = 2; rowIdx < values.length; ++rowIdx) {
      const row = values[rowIdx];
      if (!row.length) continue;
      const rowName = row[0].trim();
      if (!rowName) continue;

      // test
      if (rowName === 'break') break;

      if (data[tableName][rowName])
        throw new Error(`Duplicate item ${rowName} in table ${tableName}`);
      data[tableName][rowName] = {};
      for (let colIdx = 0; colIdx < row.length; ++colIdx) {
        if (!trimmedTitle[colIdx]) continue;
        data[tableName][rowName][trimmedTitle[colIdx]] = parseEntry(
          tableName,
          rowName,
          trimmedTitle[colIdx],
          values[rowIdx][colIdx]
        );
        if (trimmedTitle[colIdx] === 'partNumber')
          data[tableName][rowName].name = data[tableName][rowName].partNumber;
        else if (trimmedTitle[colIdx] === 'fieldName')
          data[tableName][rowName].index = rowIdx - 1;
      }
    }
    return data;
  }, {});
}

function parseEntry(tableName, rowName, title, entry) {
  if (entry === '') return;
  switch (title) {
    case 'blocks':
    case 'blockDependents':
    case 'secondaryBlockDependents':
      let jsonObj;
      try {
        jsonObj = JSON.parse(entry);
      } catch (e) {
        throw new Error(
          `Invalid JSON of ${title} for ${rowName} in table ${tableName}!`
        );
      }
      return jsonObj;
    case 'attributeGroups':
    case 'attributes':
    case 'dependents':
    case 'attribute':
    case 'reference':
      return entry
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value !== '')
        .map((value) => {
          const valueAsNum = Number(value);
          return !!valueAsNum || valueAsNum === 0 ? valueAsNum : value;
        });
    default:
  }
  if (entry === 'TRUE') return true;
  const entryAsNum = Number(entry);
  return Number.isNaN(entryAsNum) ? entry : entryAsNum;
}

// validation spreadsheet data as well as refactor data into desired format.
function validation(parsedData) {
  // validation table
  const tableNames = [
    'tabs',
    'attributeGroups',
    'attributes',
    'products',
    'compatibility',
    'tools',
    'form',
  ];
  tableNames.forEach((tableName) => {
    if (!parsedData[tableName])
      throw new Error(`Missing table ${tableName} in spreadsheet!`);
  });
  tabsValidation(parsedData);
  attributeGroupsValidation(parsedData);
  productsValidation(parsedData);
  attributesValidation(parsedData);
  compatibilityValidation(parsedData);
  baseDataValidation(parsedData);
  formDataValidation(parsedData);
}

function tabsValidation(parsedData) {
  const { tabs, attributeGroups } = parsedData;
  if (!tabs.start)
    throw new Error(`Tab with name start is required in tabs table!`);

  Object.values(tabs).forEach((tab) => {
    if (!tab.attributeGroups)
      throw new Error(`Tab ${tab.name} missing attributeGroups!`);
    tab.attributeGroups = Array.isArray(tab.attributeGroups)
      ? tab.attributeGroups.filter((attributeGroup) => !!attributeGroup)
      : [tab.attributeGroups];
    tab.attributeGroups.forEach((attributeGroup) => {
      if (!attributeGroups[attributeGroup])
        throw new Error(
          `Tab ${
            tab.name
          } contains attributeGroup ${attributeGroup} that is not defined in attributeGroups table!`
        );
    });
  });
}

function attributeGroupsValidation(parsedData) {
  const { attributeGroups, attributes } = parsedData;
  Object.values(attributeGroups).forEach((attributeGroup) => {
    if (!attributeGroup.attributes)
      throw new Error(
        `AttributeGroup ${attributeGroup.name} missing attributes!`
      );
    attributeGroup.attributes = Array.isArray(attributeGroup.attributes)
      ? attributeGroup.attributes.filter((attribute) => !!attribute)
      : [attributeGroup.attributes];
    attributeGroup.attributes.forEach((attribute) => {
      if (!attributes[attribute])
        throw new Error(
          `AttributeGroup ${
            attributeGroup.name
          } contains attribute ${attribute} that is not defined in attributes table!`
        );
    });
  });
}

function productsValidation(parsedData) {
  const { attributes, products } = parsedData;
  Object.values(products).forEach((product) => {
    if (!product.attribute)
      throw new Error(`Product ${product.name} missing attribute!`);
    (Array.isArray(product.attribute)
      ? product.attribute
      : [product.attribute]
    ).forEach((attribute) => {
      if (!attributes[attribute])
        throw new Error(
          `Product ${product.name} has invalid attribute ${attribute}!`
        );
      if (!attributes[attribute].products)
        attributes[attribute].products = [product.name];
      else attributes[attribute].products.push(product.name);
    });
    const isReference = product.name.endsWith && product.name.endsWith('*');
    if (!isReference) return;
    if (!product.reference)
      throw new Error(
        `Reference product ${product.name} missing reference data!`
      );
    product.reference.forEach((ref) => {
      if (ref.endsWith('*'))
        throw new Error(
          `Reference product ${
            product.name
          } can not refer to other reference product!`
        );
      if (!products[ref])
        throw new Error(
          `Reference product ${
            product.name
          } refers to the product ${ref} that is not defined in product table!`
        );
    });
  });
}

function attributesValidation(parsedData) {
  const { attributes } = parsedData;
  Object.values(attributes).forEach((attribute) => {
    if (attribute.dependents) {
      attribute.dependents = Array.isArray(attribute.dependents)
        ? attribute.dependents.filter((dependent) => !!dependent)
        : [attribute.dependents];
      attribute.dependents.forEach((dependent) => {
        if (!attributes[dependent])
          throw new Error(
            `Attribute ${
              attribute.name
            } contains invalid dependents attribute ${dependent} that is not defined in attributes table!`
          );
        if (!attributes[dependent].dependOn)
          attributes[dependent].dependOn = [attribute.name];
        else attributes[dependent].dependOn.push(attribute.name);
      });
    }

    // attribute.blocks xor attribute.blocksDependenst
    if (
      attribute.blocks ? !attribute.blockDependents : attribute.blockDependents
    )
      throw new Error(
        `Attribute ${
          attribute.name
        } has invalid block data in attributes table. blocks and blockDependents must be both defined or empty!`
      );
    const blockDependMap = {
      blockDependents: 'blockDependOn',
      secondaryBlockDependents: 'secondaryBlockDependOn',
    };
    Object.entries(blockDependMap).forEach(([propertyName, mappedName]) => {
      const property = attribute[propertyName];
      if (!property) return;
      Object.keys(property).forEach((blockName) => {
        if (!attribute.blocks[blockName])
          throw new Error(
            `Missing definition of block ${blockName} in blocks property of Attribute ${
              attribute.name
            } in attributes table!`
          );
        property[blockName].forEach((blockDependAttr) => {
          if (!attributes[blockDependAttr])
            throw new Error(
              `${propertyName} of attribute ${
                attribute.name
              } contains invalid attribute ${blockDependAttr} in attributes table!`
            );

          if (!attributes[blockDependAttr][mappedName])
            attributes[blockDependAttr][mappedName] = [
              [attribute.name, blockName],
            ];
          else
            attributes[blockDependAttr][mappedName].push([
              attribute.name,
              blockName,
            ]);
        });
      });
    });
  });
}

function compatibilityValidation(parsedData) {
  const { products, compatibility } = parsedData;
  Object.keys(compatibility).forEach((dependOnProduct) => {
    if (!products[dependOnProduct])
      throw new Error(
        `Invalid product ${dependOnProduct} in compatibility table!`
      );
    Object.keys(compatibility[dependOnProduct]).forEach((compatibleProduct) => {
      if (!products[compatibleProduct])
        throw new Error(
          `Invalid product ${compatibleProduct} for product ${dependOnProduct} in compatibility table!`
        );
    });
  });
}

function baseDataValidation(parsedData) {
  const { attributes, products } = parsedData;
  parsedData.bases = (attributes.base.products || []).reduce(
    (bases, product) => {
      const { label, width, depth, name } = products[product];
      if (!(width && depth))
        throw new Error(`Base ${name} missing width or depth!`);
      if (!bases[label]) bases[label] = {};
      if (!bases[label][depth]) bases[label][depth] = {};
      if (bases[label][depth][width])
        throw new Error(
          `Base ${name} and ${
            bases[label][depth][width]
          } has the same label, depth and width!`
        );
      bases[label][depth][width] = name;
      return bases;
    },
    {}
  );
}

function formDataValidation(parsedData) {
  const { form } = parsedData;
  Object.keys(form).forEach((fieldName) => {
    const width = form[fieldName].width;
    if (!width) throw new Error(`Field ${fieldName} missing width!`);
    const widthAsNum =
      width.endsWith('%') && Number(width.substring(0, width.length - 1));
    if (!widthAsNum || widthAsNum < 0 || widthAsNum > 100)
      throw new Error(`Field ${fieldName} has invalid width data!`);
  });
}



// WEBPACK FOOTER //
// ./src/scripts/buildCompatData.js